import {isNotNil} from 'ramda';

type BuildGoogleCalendarUrlOptions = {
  title: string;
  start: Date;
  end: Date;
  location?: string;
};

const GOOGLE_CALENDAR_URL = 'https://calendar.google.com/calendar/render';

const formatGoogleCalendarDate = (date: Date): string =>
  date
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}Z$/, 'Z');

export function buildGoogleCalendarUrl(options: BuildGoogleCalendarUrlOptions): string {
  const url = new URL(GOOGLE_CALENDAR_URL);
  url.searchParams.set('action', 'TEMPLATE');
  url.searchParams.set('text', options.title);
  url.searchParams.set(
    'dates',
    `${formatGoogleCalendarDate(options.start)}/${formatGoogleCalendarDate(options.end)}`
  );

  if (isNotNil(options.location)) {
    url.searchParams.set('location', options.location);
  }

  return url.toString();
}
